export enum EventMessages {
  LoadSampleCollection = "loadSampleCollection",
}
